import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const SCORING_MATRICES_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('SCORING_MATRICES');
export const SCORING_MATRICES_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	SCORING_MATRICES_CRUD_ACTION_CONSTANTS
);
